import { TransformWrapper, TransformComponent } from 'react-zoom-pan-pinch'
import { ModalViewMediaProps } from '~types'
import styles from './ModalViewMedia.module.scss'
import Image from 'next/image'
import Video from 'components/elements/Video/Video'
import cx from 'classnames'

const ModalViewMedia = ({ mediaAsset, mediaVideo, onMediaLoad }: ModalViewMediaProps) => {
  const { url: imageUrl, altText, width, height } = mediaAsset || {}

  return (
    <div className={styles['view']}>
      <div
        className={cx(
          styles['modal-media-wrapper'],
          mediaVideo && styles['modal-media-wrapper--video'],
          imageUrl && styles['modal-media-wrapper--image']
        )}
      >
        {mediaVideo && (
          <Video
            {...mediaVideo}
            allowPause
            allowVolume
            allowFullscreen
            isInModal
            autoPlay={false}
            onMediaLoad={onMediaLoad}
            className={styles['video-media']}
          />
        )}
        {imageUrl && (
          <TransformWrapper
            initialScale={1}
            minScale={1}
            maxScale={4}
            centerOnInit
            wheel={{ step: 0.2 }}
            doubleClick={{ disabled: true }}
          >
            <TransformComponent>
              <Image
                src={imageUrl}
                alt={altText || ''}
                width={width}
                height={height}
                onLoadingComplete={() => {
                  onMediaLoad?.()
                }}
                priority
                className={styles['image-media']}
              />
            </TransformComponent>
          </TransformWrapper>
        )}
      </div>
    </div>
  )
}

export default ModalViewMedia
